import React, { useState, useEffect } from 'react';
import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import CSTVDropDown from '../eir-dropdown-menu/CSTVDropDown';
import { formatAddress } from '../eir-broadband/Broadband.util';
import fetchInfo from '../../../util/fetchModalData';

const CrossSellSubscriptionSelectionModal = ({
  subscriptions,
  func,
  setOpenSubscriptionSelectionModal,
}) => {
  // eslint-disable-next-line
  const [open, setOpen] = useState(true);
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  // const theme = useTheme();
  const { publicRuntimeConfig } = getConfig();

  const numbers = [];
  subscriptions?.map(subscription =>
    numbers.push({
      value: subscription.id,
      label: subscription.id,
      addressInfo: formatAddress(subscription?.addressInfo, subscription?.servicesForSubscription),
      changeOffer: subscription?.coEligiblity?.contractRenewal,
      totalAmountVatIncluded:
        subscription?.coEligiblity?.earlyCeaseChargeList?.totalAmountVatIncluded,
    })
  );
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'CROSS-SELL-TV',
      });

      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);
  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={open}
      desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
      }`}
      mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
      }`}
      desktopImageAlt={
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
      }
      mobileImageAlt={cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText}
      desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url || ''
      }`}
      mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url || ''
      }`}
      title={cmsCollectionData?.attributes?.title}
      description={
        <CSTVDropDown
          numbers={numbers}
          func={func}
          setOpenSubscriptionSelectionModal={setOpenSubscriptionSelectionModal}
        />
      }
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      enableBackCTA
      backCTAFunc={setOpenSubscriptionSelectionModal}
      load={load}
    />
  );
};

export default CrossSellSubscriptionSelectionModal;
